import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEO from '@/components/feature/SEO';
import HeroSection from './components/HeroSection';
import FeaturedGrid from './components/FeaturedGrid';
import HotTracking from './components/HotTracking';
import UserComments from './components/UserComments';
import CTASection from './components/CTASection';

const homeSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: '黑料吃瓜网 - 首页',
  description: '黑料吃瓜网官网直连黑料吃瓜网站、黑料吃瓜网www与黑料吃瓜网曝一区二区等热门板块，第一时间捕捉全网最新网红黑料。',
  url: 'http://cgshe.cn/',
  isPartOf: {
    '@type': 'WebSite',
    name: '黑料吃瓜网',
    url: 'http://cgshe.cn/',
  },
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        name: '首页',
        item: 'http://cgshe.cn/',
      },
    ],
  },
};

export default function Home() {
  return (
    <>
      <SEO
        title="黑料吃瓜网 - 黑料吃瓜网站与www入口 | 黑料吃瓜网曝一区二区不打烊"
        description="黑料吃瓜网官网直连黑料吃瓜网站、黑料吃瓜网www与黑料吃瓜网曝一区二区等热门板块。整站资源持续更新，入口稳定在线，第一时间捕捉全网最新网红黑料与每日吃瓜大赛劲爆内容。"
        keywords="黑料吃瓜网,黑料吃瓜网站,黑料吃瓜网www,黑料吃瓜网曝一区二区,黑料不打烊,吃瓜入口,网红爆料,52黑料吃瓜网"
        canonical="http://cgshe.cn/"
        schemaJson={homeSchema}
      />

      <Navbar />

      <main>
        <HeroSection />
        <FeaturedGrid />
        <HotTracking />
        <UserComments />
        <CTASection />
      </main>

      <Footer />
    </>
  );
}